import template from './ecocode-trustpilot-invitation.html.twig';

Shopware.Component.register('ecocode-trustpilot-invitation', {
    template,
    emits:['frw-set-title','buttons-update','frw-redirect', 'modal-close'],
    created() {
        this.createdComponent();
    },
    methods: {
        createdComponent() {
            this.updateButtons();
            this.setTitle();
        },
        setTitle() {
            this.$emit('frw-set-title', this.$tc('ecocode-trustpilot.configure.modalTitle'));
        },
        async sendInvitation() {
            this.isLoading = true;
            await this.$refs.invitation.inviteAction();
            this.$emit('frw-redirect', 'ecocode.trustpilot.setup.finish');
            this.isLoading = false;
        },
        updateButtons() {
            const buttonConfig = [
                {
                    key: 'back',
                    label: this.$tc('ecocode-trustpilot.general.buttonBack'),
                    position: 'left',
                    variant: null,
                    action: 'ecocode.trustpilot.setup.configure',
                    disabled: false
                },
                {
                    key: 'cancel',
                    label: this.$tc('ecocode-trustpilot.general.buttonCancel'),
                    position: 'right',
                    variant: null,
                    action: this.onCancel.bind(this),
                    disabled: false
                },
                {
                    key: 'skip',
                    label: this.$tc('ecocode-trustpilot.general.buttonSkip'),
                    position: 'right',
                    variant: null,
                    action: 'ecocode.trustpilot.setup.finish',
                    disabled: false
                },
                {
                    key: 'next',
                    label: this.$tc('ecocode-trustpilot.general.buttonNext'),
                    position: 'right',
                    variant: 'primary',
                    action: this.sendInvitation.bind(this),
                    disabled: false
                }
            ];

            this.$emit('buttons-update', buttonConfig);
        },
        onCancel() {
            this.$emit('modal-close');
        }
    }

});
